import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ReactComponent as TrashIcon } from './assets/icon-trash.svg';
import './styles.scss';

interface Props {
  title: string;
  name: string;
  handleDelete?: any;
  onClose(): void;
}

const DeleteConfirmationModal: React.FC<Props> = ({ title, name, handleDelete, onClose }) => (
  <>
    <Modal.Header closeButton={true}>
      <Modal.Title as="div" bsPrefix="title">
        {title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="modal_content">
        <div className="trash-icon">
          <TrashIcon />
        </div>
        <div className="question">Are you sure you want to delete {name}?</div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button className="btn-cancel" onClick={() => onClose()}>
        Cancel
      </Button>
      <Button className="btn-confirm" onClick={() => handleDelete()}>
        Delete
      </Button>
    </Modal.Footer>
  </>
);

export default DeleteConfirmationModal;
